module.exports = __webpack_public_path__ + "img/x_.541857af.svg";